const Typography = theme => {
  return {
    h1: {
      fontWeight: 600,
      fontSize: '1.75rem',
      lineHeight: 1.25,
      letterSpacing: '-0.02em',
      color: theme.palette.text.primary
    },
    h2: {
      fontWeight: 600,
      fontSize: '1.5rem',
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
      color: theme.palette.text.primary
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.25rem',
      lineHeight: 1.35,
      letterSpacing: '-0.01em',
      color: theme.palette.text.primary
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.125rem',
      lineHeight: 1.4,
      letterSpacing: 0,
      color: theme.palette.text.primary
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.4,
      letterSpacing: 0,
      color: theme.palette.text.primary
    },
    h6: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: 1.45,
      letterSpacing: '0.01em',
      color: theme.palette.text.primary
    },
    subtitle1: {
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.5,
      letterSpacing: '0.01em',
      color: theme.palette.text.primary
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: '0.8125rem',
      lineHeight: 1.45,
      letterSpacing: '0.01em',
      color: theme.palette.text.secondary
    },
    body1: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      letterSpacing: '0.01em',
      color: theme.palette.text.primary
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      letterSpacing: '0.01em',
      color: theme.palette.text.secondary
    },
    button: {
      fontWeight: 500,
      fontSize: '0.875rem',
      lineHeight: 1.5,
      letterSpacing: '0.01em',
      textTransform: 'none',
      color: theme.palette.text.primary
    },
    caption: {
      fontSize: '0.75rem',
      lineHeight: 1.4,
      letterSpacing: '0.02em',
      color: theme.palette.text.secondary
    },
    overline: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
      letterSpacing: '0.04em',
      textTransform: 'none',
      color: theme.palette.text.secondary
    },
    // Custom typography (preserved for existing usage)
    'fm-h1': {
      fontSize: '1.75rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.25
    },
    'fm-h2': {
      fontSize: '1.5rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.3
    },
    'fm-h3': {
      fontSize: '1.25rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.35
    },
    'fm-h4': {
      fontSize: '1.125rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.4
    },
    'fm-h5': {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.4
    },
    'fm-h6': {
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: 1.45
    },
    'fm-p1': {
      fontSize: '1rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.5
    },
    'fm-p2': {
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.5
    },
    'fm-p3': {
      fontSize: '0.8125rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: 1.45
    }
  }
}

export default Typography
